export const LoadingLottieAnimation = {
    path: 'assets/lottie/loading.json',
    renderer: 'canvas',
    autoplay: true,
    loop: true
};

// https://lottiefiles.com/3327-spinner
